"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("./layout.js");

var _Actions = _interopRequireDefault(require("./Actions.js"));

var _CFontIcon = _interopRequireDefault(require("./CFontIcon.js"));

var _CLink = _interopRequireDefault(require("./CLink.js"));

require("prop-types");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("react-router-dom");

require("classnames");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject9() {
  var data = (0, _chunkB2edacfb.a)(["\n  width: 100%;\n  background-color: white;\n  border-bottom: 1px solid ", ";\n  margin: 0;\n  margin-top: -1px;\n  margin-bottom: 20px;\n  padding: 0 ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _chunkB2edacfb.a)(["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _chunkB2edacfb.a)(["\n  width: 100%;\n  font-size: 14px;\n  line-height: 24px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _chunkB2edacfb.a)(["\n  margin-top: 20px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 28px ", " 15px;\n  width: 100%;\n  background-color: white;\n  border-bottom: 1px solid ", ";\n  align-items: center;\n\n  h1 {\n    padding-right: 16px;\n  }\n\n  & + ", ", & + ", " {\n    margin-top: -33px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _chunkB2edacfb.a)(["\n  width: 100%;\n  height: 0;\n  border-bottom: 1px solid ", ";\n  margin-bottom: 20px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n  background-color: white;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  height: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  max-width: 1240px;\n  width: 100%;\n  padding: 0 ", ";\n  margin: 0 auto;\n  margin-top: 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: block;\n  flex-grow: 1;\n  width: 100%;\n  padding: 0;\n  .CPage-Container:last-of-type {\n    padding-bottom: 8rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PADDING_LEFT_RIGHT = "60px";
var CPage = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "CPage",
  componentId: "sc-5078jc-0"
})(_templateObject());
CPage.displayName = "CPage";
CPage.Container = (0, _styledComponents.default)(_layout.Box).attrs({
  className: "CPage-Container"
}).withConfig({
  displayName: "CPage__Container",
  componentId: "sc-5078jc-1"
})(_templateObject2(), PADDING_LEFT_RIGHT);
CPage.Container.displayName = "CPage.Container";
CPage.LegacyContainer = (0, _styledComponents.default)(CPage.Container).withConfig({
  displayName: "CPage__LegacyContainer",
  componentId: "sc-5078jc-2"
})(_templateObject3());
CPage.LegacyContainer.displayName = "CPage.LegacyContainer";
CPage.Divider = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "CPage__Divider",
  componentId: "sc-5078jc-3"
})(_templateObject4(), function (props) {
  return props.theme["$dark-tint-10"];
});
var StyledTitleBar = (0, _styledComponents.default)(_layout.CRow).withConfig({
  displayName: "CPage__StyledTitleBar",
  componentId: "sc-5078jc-4"
})(_templateObject5(), PADDING_LEFT_RIGHT, function (props) {
  return props.theme["$dark-tint-10"];
}, CPage.SecondBar, CPage.LegacyContainer);

CPage.TitleBar = function (props) {
  return _react.default.createElement(StyledTitleBar, props, props.children);
};

CPage.TitleBar.displayName = "CPage.TitleBar";
var StyledActionsContainer = (0, _styledComponents.default)(_layout.CRow).withConfig({
  displayName: "CPage__StyledActionsContainer",
  componentId: "sc-5078jc-5"
})(_templateObject6());
CPage.TitleBar.displayName = "CPage.TitleBar";

CPage.TitleBar.Content = function (props) {
  return _react.default.createElement(_layout.CCol, {
    xs: 12,
    sm: true
  }, _react.default.createElement(_layout.CRow, {
    start: "xs",
    middle: "xs"
  }, props.children));
};

CPage.TitleBar.Content.displayName = "CPage.TitleBar.Content";

CPage.TitleBar.Actions = function (props) {
  return _react.default.createElement(_layout.CCol, {
    xs: 12,
    sm: true
  }, _react.default.createElement(StyledActionsContainer, {
    start: "xs"
  }, _react.default.createElement(_Actions.default, (0, _chunkB2edacfb.g)({
    marginBottom: 4
  }, props))));
};

CPage.TitleBar.Actions.propTypes = _Actions.default.propTypes;
CPage.TitleBar.Actions.defaultProps = _Actions.default.defaultProps;
CPage.TitleBar.Actions.displayName = "CPage.TitleBar.Actions";

CPage.TitleBar.BreadcrumbLink = function (props) {
  return _react.default.createElement(StyledBreadcrumbLink, null, _react.default.createElement(StyledLink, props, _react.default.createElement(_CFontIcon.default, {
    className: "fas fa-arrow-left",
    marginRight: 8
  }), props.children));
};

var StyledBreadcrumbLink = (0, _styledComponents.default)(_layout.CRow).withConfig({
  displayName: "CPage__StyledBreadcrumbLink",
  componentId: "sc-5078jc-6"
})(_templateObject7());
var StyledLink = (0, _styledComponents.default)(_CLink.default).withConfig({
  displayName: "CPage__StyledLink",
  componentId: "sc-5078jc-7"
})(_templateObject8(), function (props) {
  return props.theme["$gray-5"];
}, function (props) {
  return props.theme["$gray-6"];
});
CPage.TitleBar.BreadcrumbLink.displayName = "CPage.TitleBar.BreadcrumbLink";
CPage.SecondBar = (0, _styledComponents.default)(_layout.CRow).withConfig({
  displayName: "CPage__SecondBar",
  componentId: "sc-5078jc-8"
})(_templateObject9(), function (props) {
  return props.theme["$dark-tint-10"];
}, PADDING_LEFT_RIGHT);
CPage.SecondBar.displayName = "CPage.SecondBar";
var _default = CPage;
exports.default = _default;